export default __webpack_public_path__ + "static/media/punte alberete 5 P.bbf6dec3.mp3";